(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sbe-collection-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sbe-mega-menu')) {
customElements.define('sbe-mega-menu', class extends HTMLElement {
connectedCallback() {
if (this.ready) return;
this.ready = true;
this.details = this.querySelector('details');
this.summary = this.querySelector('summary');
this.controller = new AbortController();
const options = { signal: this.controller.signal };
this.addEventListener('pointerenter', (event) => {
if (event.pointerType !== 'mouse' || !matchMedia('(hover:hover)').matches) return;
clearTimeout(this.closeTimer);
this.openTimer = setTimeout(() => { this.details.open = true; }, 90);
}, options);
this.addEventListener('pointerleave', (event) => {
if (event.pointerType !== 'mouse') return;
clearTimeout(this.openTimer);
this.closeTimer = setTimeout(() => {
if (!this.contains(document.activeElement)) this.details.open = false;
}, 200);
}, options);
this.details.addEventListener('toggle', () => {
this.summary.setAttribute('aria-expanded', String(this.details.open));
const sticky = this.closest('sticky-header');
if (sticky) sticky.preventHide = this.details.open;
}, options);
this.querySelectorAll('[data-menu-choice]').forEach((choice) => {
const show = () => {
this.querySelectorAll('[data-menu-choice]').forEach((item) => item.classList.toggle('is-selected', item === choice));
this.querySelectorAll('[data-menu-preview]').forEach((pane) => { pane.hidden = pane.dataset.menuPreview !== choice.dataset.menuChoice; });
};
choice.addEventListener('pointerenter', show, options);
choice.addEventListener('focus', show, options);
});
document.addEventListener('pointerdown', (event) => {
if (!this.contains(event.target)) this.details.open = false;
}, options);
this.addEventListener('keydown', (event) => {
if (event.key === 'Escape') {
clearTimeout(this.openTimer);
this.details.open = false;
this.summary.focus();
}
}, options);
this.addEventListener('focusout', () => {
setTimeout(() => { if (!this.contains(document.activeElement)) this.details.open = false; }, 0);
}, options);
}
disconnectedCallback() {
this.controller?.abort();
clearTimeout(this.openTimer);
clearTimeout(this.closeTimer);
const sticky = this.closest('sticky-header');
if (sticky) sticky.preventHide = false;
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sbe-fabric-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sbe-fabric-picker')) {
  customElements.define('sbe-fabric-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.error = this.querySelector('.sbe-fabric__error');
      this.addEventListener('change', (event) => {
        if (event.target.name === 'properties[Fabric]') {
          this.querySelectorAll('[data-colour-group]').forEach((group) => {
            const active = group.dataset.colourGroup === event.target.value;
            group.hidden = !active;
            group.disabled = !active;
            group.querySelectorAll('input').forEach((input) => { input.checked = false; });
          });
          this.querySelector('.sbe-fabric__chosen').hidden = true;
          this.querySelector('.sbe-fabric__prompt').hidden = false;
          this.error.hidden = true;
        }
        if (event.target.name === 'properties[Colour]') {
          const input = event.target;
          this.querySelector('[data-selected-image]').src = input.dataset.image + '&width=128';
          this.querySelector('[data-selected-label]').textContent = input.dataset.label;
          this.querySelector('.sbe-fabric__chosen').hidden = false;
          this.querySelector('.sbe-fabric__prompt').hidden = true;
          this.error.hidden = true;
        }
      });
      this.querySelector('[data-preview]').addEventListener('click', () => {
        const selected = this.querySelector('input[name="properties[Colour]"]:checked');
        if (!selected) return;
        const image = this.querySelector('[data-large-image]');
        image.src = selected.dataset.image;
        image.alt = selected.dataset.label;
        this.dialog.querySelector('h3').textContent = selected.dataset.label;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
    }
    validateSelection() {
      const selected = this.querySelector('input[name="properties[Colour]"]:checked');
      const family = this.querySelector('input[name="properties[Fabric]"]:checked');
      if (selected && family && selected.dataset.family === family.value && !selected.closest('fieldset').disabled) return true;
      this.error.hidden = false;
      this.querySelector('[data-colour-group]:not([hidden]) input')?.focus();
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
